export default function Difference() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            和一次性買斷網站的差別
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* 一次性買斷 */}
          <div className="bg-gray-50 rounded-2xl p-8 md:p-10 border border-gray-200">
            <div className="flex items-center mb-6">
              <div className="w-14 h-14 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <i className="ri-shopping-bag-line text-2xl text-gray-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">一次性買斷網站</h3>
            </div>
            
            <div className="space-y-4">
              <p className="text-base text-gray-700 leading-relaxed">
                一次性買斷網站，<br />
                通常只負責<strong className="text-gray-900">「做完交付」</strong>。
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                後續若有修改、維護或問題處理，<br />
                多半需要另外找人或重新報價。
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-300">
              <div className="space-y-3">
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 text-lg mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-sm text-gray-600">完成後無後續支援</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 text-lg mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-sm text-gray-600">修改需額外報價</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 text-lg mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-sm text-gray-600">問題處理需重新聯繫</span>
                </div>
              </div>
            </div>
          </div>

          {/* 年度管理方案 */}
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 md:p-10 border-2 border-teal-300">
            <div className="flex items-center mb-6">
              <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mr-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">年度管理方案</h3>
            </div>
            
            <div className="space-y-4">
              <p className="text-base text-gray-700 leading-relaxed">
                年度管理方案則是以<strong className="text-teal-600">「持續服務」</strong>為核心，<br />
                讓網站在使用過程中，<br />
                始終有對應的窗口與支援。
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-teal-200">
              <div className="space-y-3">
                <div className="flex items-start">
                  <i className="ri-checkbox-line text-teal-600 text-lg mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700 font-medium">持續代管與維運</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-line text-teal-600 text-lg mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700 font-medium">基本調整納入服務</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-line text-teal-600 text-lg mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700 font-medium">固定窗口隨時支援</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
